/**
 * Utilidades para formateo de precios en formato español
 */

/**
 * Formatea el precio con coma decimal y símbolo de euro
 * @param price - Precio como número o string
 * @returns Precio formateado en español (ej: "12,99 €")
 */
export function formatPrice(price: number | string): string {
  // Permitir 0 como valor válido
  if (price === null || price === undefined || price === 'N/A') return 'N/A';
  
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numericPrice)) return 'N/A';
  
  // Formatear con coma decimal y símbolo de euro al final
  return `${numericPrice.toFixed(2).replace('.', ',')} €`;
}

/**
 * Formatea el precio con separadores de miles
 * @param price - Precio como número o string
 * @returns Precio formateado con separadores (ej: "1.234,56 €")
 */
export function formatPriceWithThousands(price: number | string): string {
  // Permitir 0 como valor válido
  if (price === null || price === undefined || price === 'N/A') return 'N/A';
  
  const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
  
  if (isNaN(numericPrice)) return 'N/A';
  
  // Formatear con separadores de miles, coma decimal y símbolo de euro
  return `${numericPrice.toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} €`;
}

/**
 * Obtiene el precio más apropiado de un producto de PrestaShop
 * @param product - Objeto del producto de PrestaShop
 * @returns Precio formateado o 'N/A'
 */
export function getProductPrice(product: any): string {
  const rawPrice = product.price || 
                   product.price_without_reduction || 
                   product.wholesale_price || 
                   'N/A';
  
  return formatPrice(rawPrice);
}

/**
 * Obtiene el precio con separadores de miles
 * @param product - Objeto del producto de PrestaShop
 * @returns Precio formateado con separadores o 'N/A'
 */
export function getProductPriceWithThousands(product: any): string {
  const rawPrice = product.price || 
                   product.price_without_reduction || 
                   product.wholesale_price || 
                   'N/A';
  
  return formatPriceWithThousands(rawPrice);
} 